import { render, staticRenderFns } from "./compareDetails.vue?vue&type=template&id=5407c0f4"
import script from "./compareDetails.vue?vue&type=script&lang=js"
export * from "./compareDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports